<script>
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import CostDescription from './CostDescription.svelte';

	let { cards } = $props();

	let CARDS = $derived({
		sleepPanel: false,
		standard: true,
		performance: true,
		commercial: true,
		...cards,
	});
</script>

<Grid columns={3} rows={3} center class="mb-8 gap-x-8">
	{#if CARDS.sleepPanel}
		<Grid subgrid vertical>
			<p class="mb-0 text-2xl font-thin">Sleep Panel</p>
			<CostDescription
				costAverage="336"
				costPerSquareFoot="28"
				bgColor="blue"
			/>
			<p>
				<em>
					Blocks 100% of light for total darkness. For light sensitivity,
					migraine sufferers, and light sleepers.
				</em>
			</p>
		</Grid>
	{/if}

	{#if CARDS.standard}
		<Grid subgrid vertical>
			<p class="mb-0 text-2xl font-thin">Standard Grade</p>
			<CostDescription costAverage="372" costPerSquareFoot="31" />
			<p>
				<em>
					Our workhorse interior storm window insert blocks drafts and reduces
					outside noise.
				</em>
			</p>
		</Grid>
	{/if}

	{#if CARDS.performance}
		<Grid subgrid vertical>
			<p class="mb-0 text-2xl font-thin">Performance Grade</p>
			<CostDescription
				costPerSquareFoot="40"
				costAverage="480"
				bgColor="yellow"
			/>
			<p>
				<em>
					Our 4 options in performance grade inserts provide superior protection
					against noise and light.
				</em>
			</p>
		</Grid>
	{/if}

	{#if CARDS.commercial}
		<Grid subgrid vertical>
			<p class="mb-0 text-2xl font-thin">Commercial Grade</p>
			<CostDescription
				costPerSquareFoot="44"
				costAverage="588"
				bgColor="green"
			/>
			<p>
				<em>
					Industrial strength inserts with a scratch-resistant coating can be
					cleaned with common products.
				</em>
			</p>
		</Grid>
	{/if}
</Grid>
